<template>
  <div class="box">
    <div class="big_box">
      <img src="../../../assets/img/subimt.png" alt="" />
      <p class="w1">祝贺你，提交成功！</p>
      <p class="w2">论文编号：{{ id }}</p>
      <div class="w3">
        <p><img src="../../../assets/img/tjcg_icon.png" alt="" /></p>
        <p @click="$router.push('/Home/tal')">管理我的论文</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: ['id'],
  data() {
    return {
      form: {
        name: '',

        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        }
      ],
      value: '',
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      ids: ''
    }
  },

  components: {},
  methods: {}
}
</script>
<style lang="less" scoped>
.big_box {
  width: 1200px;
  height: 560px;
  background-color: #ffffff;
  margin-bottom: 115px;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-top: 113px;
    width: 92px;
    height: 92px;
  }
  .w1 {
    margin-top: 10px;
    font-family: SourceHanSansCN-Regular;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #00599e;
  }
  .w2 {
    margin-top: 10px;
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #888888;
  }
  .w3 {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    width: 200px;
    height: 60px;
    border-radius: 5px;
    border: solid 1px #c9dcea;
    font-size: 20px;

    line-height: 60px;
    letter-spacing: 0px;
    color: #00599e;
    img {
      margin-top: 24px;
      margin-right: 4px;
      width: 28px !important;
      height: 26px !important;
    }
  }
}
.box {
  //   width: 1920px;
  //   height: 1572px;
  background-color: #f6fbff;
  .big_btn {
    width: 440px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    .trs_btn {
      width: 200px;
      height: 60px;
      border-radius: 5px;
      background: #fff;
      border: solid 1px #c9dcea;
      font-family: SourceHanSansCN-Regular;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #00599e;
    }
    button {
      width: 200px;
      height: 60px;
      background-color: #00599e;
      border-radius: 5px;
      border: 0;
      font-size: 20px;

      color: #fff;
      margin-top: 40px;
      margin-bottom: 73px;
    }
  }
}
</style>
